import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  StudyFile,
  StudyFileUpload,
} from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';
import { BackgroundFileService } from 'src/app/shared-new/services/background-file.service';
import { Study } from '../../../../models/Study/study.model';
import { EventsEmitter } from '../../../../shared/event-emitter/EventEmitter';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { takeUntil } from 'rxjs';
import { BaseUnsubscribeComponent } from '../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-matched-xrays',
  templateUrl: './matched-xrays.component.html',
  styleUrls: ['./matched-xrays.component.scss'],
})
export class MatchedXraysComponent implements OnChanges {
  @Input() expectedMatchedFiles: number = 0;
  @Input() studyFiles: StudyFile[] = [];
  @Input() mediaGroups: MediaGroup[] = [];
  @Input() xraysMediaGroups: any;
  @Input() activeStudy: Study;
  @Input() headingText: string;
  @Input() mediaCategories: MediaCategory[] = [];
  @Input() filterMediaCategories: MediaCategory[] = [];
  viewMode: ViewMode = ViewMode.DRAFT;

  @Input() saleId: number;
  @Input() horseId: number;
  @Input() studyId: number;
  @Input() saleName: string = '';
  @Input() horseName: string = '';
  @Input() lot: string = '';

  ViewMode = ViewMode;
  @Output() changeMediaCategory: EventEmitter<{
    studyFile: StudyFile;
    mediaCategoryId: number;
  }> = new EventEmitter<{ studyFile: StudyFile; mediaCategoryId: number }>();
  @Output() uploadAsAdditional: EventEmitter<{
    studyFile: StudyFile;
    isAdditional: boolean;
  }> = new EventEmitter<{ studyFile: StudyFile; isAdditional: boolean }>();
  @Output() deleteStudyFile: EventEmitter<number> = new EventEmitter<number>();
  @Output() createStudyFile: EventEmitter<{
    file: File;
    mediaCategoryId: number;
  }> = new EventEmitter<{ file: File; mediaCategoryId: number }>();
  @Output() updateStudyFileStatus: EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }> = new EventEmitter<{
    studyFileId: number;
    statusId: number;
    reason: string;
  }>();

  selectedFiles: {
    file: File;
    categoryId: number;
  }[] = [];
  constructor(
    private modalService: NgbModal,
    private readonly eventEmitter: EventsEmitter,
    private backgroundFileService: BackgroundFileService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const studyFilesNew = changes['studyFiles'];
   
    if (
      studyFilesNew?.currentValue &&
      studyFilesNew?.currentValue?.length !==
      studyFilesNew?.previousValue?.length
    ) {
      
      this.selectedFiles.splice(0, 1);
    }
  }



  emitChangeMediaCategory(model: {
    studyFile: StudyFile;
    mediaCategoryId: number;
  }): void {
    this.changeMediaCategory.emit(model);
  }

  emitUploadAsAdditional(model: {
    studyFile: StudyFile;
    isAdditional: boolean;
  }): void {
    this.uploadAsAdditional.emit(model);
  }

  emitDeleteStudyFile(studyFileId: number): void {
    this.deleteStudyFile.emit(studyFileId);
  }

  uploadFiles(event: { file: File; mediaCategoryId: number }): void {
    const model = {
      file: event.file,
      categoryId: event.mediaCategoryId,
    };
    let files: StudyFileUpload[] = [];
    const upload = {
      file: model.file,
      horseId: this.horseId,
      saleId: this.saleId,
      horseName: this.horseName,
      saleName: this.saleName,
      studyId: this.studyId,
      isAdditional: false,
      mediaCategoryId: model.categoryId,
    } as StudyFileUpload;
    files.push(upload);
    this.eventEmitter.emitFileStartUploadEvent(files);
    this.createStudyFile.emit();
  }

  checkForCategoryIdUpload(id: number): boolean {
    return !!this.selectedFiles.find((sf) => sf.categoryId === id);
  }

  emitUpdateStatus(event: {
    studyFileId: number;
    statusId: number;
    reason: string;
  }): void {
    this.updateStudyFileStatus.emit(event);
  }

  trackByGroup(index: number, el: MediaGroup): number {
    return el.id;
  }

  trackByCategory(index: number, el: any): number {
    return el?.category?.id;
  }

  trackByStudyFile(index: number, el: StudyFile): number {
    return el.studyFileId;
  }

  viewImage(data: { url: string; studyFileId: number }): void {
    const studyFile: StudyFile = this.studyFiles.filter(
      (x) => x.studyFileId === data.studyFileId
    )[0];
    //this.activityStart.emit({ studyFile, activityId: Activity.XRayView })
    const modalRef = this.modalService.open(ImageModalComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.url = data.url;
    modalRef.componentInstance.studyFile = studyFile;
    modalRef.result.then(
      (result) => {
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }
}
